module.exports = __webpack_public_path__ + "static/img/bighaibao2.03dcddd.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/page-one/img/bighaibao2.png
// module id = Ukdq
// module chunks = 0